import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { getPose } from '../data/poses';
import { formatDuration, totalSeconds } from '../hooks/useRoutines';
import type { Routine } from '../types';

type Load = 'loading' | 'error' | 'ready';

export function PublicGalleryPage() {
  const [state, setState] = useState<Load>('loading');
  const [list, setList] = useState<Routine[]>([]);

  useEffect(() => {
    let cancelled = false;
    api
      .listPublicRoutines()
      .then((rs) => {
        if (cancelled) return;
        setList(rs);
        setState('ready');
      })
      .catch(() => {
        if (!cancelled) setState('error');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="page-head">
        <h1 className="page-title">Discover</h1>
      </div>
      <p className="hint" style={{ marginTop: 0 }}>
        Routines other people have shared. Play any of them, or save a copy to make it your own.
      </p>

      {state === 'loading' && (
        <div className="empty">
          <p>Loading shared routines…</p>
        </div>
      )}

      {state === 'error' && (
        <div className="empty">
          <p>Couldn't load shared routines. Please try again.</p>
        </div>
      )}

      {state === 'ready' && list.length === 0 && (
        <div className="empty">
          <p>No shared routines yet. Share one of yours to start the collection!</p>
          <a className="btn primary" href="#/routines">
            My routines
          </a>
        </div>
      )}

      {state === 'ready' && list.length > 0 && (
        <div className="routine-list">
          {list.map((r) => {
            const names = r.steps
              .map((s) => getPose(s.poseId)?.nameEnglish)
              .filter(Boolean)
              .join(' · ');
            return (
              <div className="routine-row" key={r.id}>
                <div className="routine-meta">
                  <h2>{r.name}</h2>
                  <div className="routine-sub">
                    {r.steps.length} pose{r.steps.length === 1 ? '' : 's'} ·{' '}
                    {formatDuration(totalSeconds(r))} total
                  </div>
                  {names && <div className="routine-poses">{names}</div>}
                </div>
                <div className="routine-actions">
                  <a className="btn primary" href={`#/r/${r.id}`}>
                    View
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
